import ANTROPOLOGIA from './antropologia.json';

// eslint-disable-next-line import/prefer-default-export
export const ASIGNATURAS_CUARTO = Object.freeze(ANTROPOLOGIA);
